import React, { useEffect } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import SectionLayout from 'components/layouts/SectionLayout';
import PrivacyPolicyContent from './content/PrivacyPolicyContent';

const PrivacyPolicy = () => {

    useEffect(() => {
        // Change Tab Title
        document.title = "Privacy Policy - Insurance Enterprise"
    }, [])

    return (
        <>
            <PageLayout
                content={
                    <>
                        <SectionLayout content={<PrivacyPolicyContent />} />
                    </>
                }
            />
        </>
    );
}

export default PrivacyPolicy;
